import { fetchWithRetry } from '@tunein/web-utils';
import get from 'lodash/get';
import isBoolean from 'lodash/isBoolean';
import tuner from '../tuner';
import debug from '../debugger';
import handleInstreamError from '../player/utils/handleInstreamError';
import getAdswizzListenerId from './getAdswizzListenerId';
import { actions } from '../player/constants/logging';
import parseQuery from './parseQuery';

// eslint-disable-next-line consistent-return
export default async function getMasterManifestUrl(requestUrl) {
  debug.log('attempting to fetch master manifest url', requestUrl);

  try {
    const { timeout } = tuner.streamPlayer.getPlayerConfig();
    const host = requestUrl.substring(0, requestUrl.indexOf('/v1'));
    const {
      palNonce,
      gdprTcString,
      gdprApplies,
      isOptedOut,
      isOptedOutOfCcpaOrGlobal,
      isUserInUS,
      dfpParams = {},
      adsTargeting,
    } = get(tuner, 'tune.params', {});

    // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
    // see https://docs.google.com/document/d/1J2XU_0TN5Ix_vLdcuJd-h6vdHdPQvc2wc8fSLNu3ojA
    const adsParams = {
      ciu_szs: '300x250,728x90',
      gdfp_req: '1',
      cust_params: (await tuner.instreamCustParamsPromise) || '',
      bundleid: get(tuner, 'bundleId') || '',
      iu: get(adsTargeting, 'ads_partner_alias') || '',
      // this represents combined consent under CCPA and GDPR
      // if the GDPR TC String is available, this will simply be ignored

      ...dfpParams,
    };

    const { language } = parseQuery(adsParams.cust_params);

    if (language) {
      adsParams.hl = language;
    }

    if (palNonce) {
      adsParams.paln = palNonce;
    }

    // gdprApplies can be undefined until OneTrust determines whether GDPR applies
    if (isBoolean(gdprApplies)) {
      // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
      adsParams.gdpr = gdprApplies ? '1' : '0';
    }

    if (!isUserInUS) {
      // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
      adsParams.npa = isOptedOut ? '1' : '0'; // 0 for personalized ads, 1 for non-personalized ads
    }

    if (gdprApplies && gdprTcString) {
      adsParams.gdpr_consent = gdprTcString;
    }

    if (get(adsTargeting, 'ppid')) {
      adsParams.ppid = adsTargeting.ppid;
    }

    if (isUserInUS) {
      adsParams.rdp = isOptedOutOfCcpaOrGlobal ? '1' : '0';
    }

    const adswizzListenerId = getAdswizzListenerId();
    if (adswizzListenerId) {
      adsParams.rdid = adswizzListenerId;
      adsParams.idtype = 'adid';
    }

    const { manifestUrl, trackingUrl } = await fetchWithRetry(requestUrl, {
      post: { adsParams },
      bailTimeout: timeout,
    });

    if (manifestUrl) {
      return {
        trackingUrl: trackingUrl && `${host}${trackingUrl}`,
        manifestUrl: `${host}${manifestUrl}`,
      };
    }

    throw new Error('manifestUrl missing from response');
  } catch (error) {
    debug.log(`Fetching master manifest url: ${error.message}`, error);

    handleInstreamError(
      error,
      actions.instreamPostTimeout,
      actions.instreamPostError,
      true,
    );

    throw new Error(`Fetching master manifest url: ${error.message}`);
  }
}
